import React from 'react';
import Icon from '../../../components/AppIcon';

const CryptoCard = ({ crypto, isAOGX = false }) => {
  const isPositive = crypto?.change >= 0;
  
  return (
    <div className={`bg-card border border-border rounded-brand p-6 hover-lift transition-brand ${
      isAOGX ? 'ring-2 ring-primary/20 bg-gradient-to-br from-primary/5 to-accent/5' : ''
    }`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
            isAOGX ? 'bg-gradient-to-br from-primary to-accent' : 'bg-muted'
          }`}>
            <span className={`text-lg font-bold ${
              isAOGX ? 'text-white' : 'text-foreground'
            }`}>
              {crypto?.symbol?.charAt(0)}
            </span>
          </div>
          <div>
            <h3 className="font-semibold text-foreground">{crypto?.name}</h3>
            <p className="text-sm text-muted-foreground">{crypto?.symbol}</p>
          </div>
        </div>
        {isAOGX && (
          <div className="bg-primary text-primary-foreground px-2 py-1 rounded-brand-xs text-xs font-medium">
            Featured
          </div>
        )}
      </div>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-2xl font-bold text-foreground">
            ${crypto?.price?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 })}
          </span>
          <div className={`flex items-center space-x-1 px-2 py-1 rounded-brand-xs text-sm font-medium ${
            isPositive 
              ? 'bg-success/10 text-success' :'bg-destructive/10 text-destructive'
          }`}>
            <Icon 
              name={isPositive ? "TrendingUp" : "TrendingDown"} 
              size={14} 
            />
            <span>{Math.abs(crypto?.change)?.toFixed(2)}%</span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-muted-foreground">Market Cap</p>
            <p className="font-medium text-foreground">
              ${(crypto?.marketCap / 1e9)?.toFixed(2)}B
            </p>
          </div>
          <div>
            <p className="text-muted-foreground">Volume 24h</p>
            <p className="font-medium text-foreground">
              ${(crypto?.volume / 1e6)?.toFixed(2)}M
            </p>
          </div>
        </div>

        <div className="pt-3 border-t border-border">
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span>24h Range</span>
            <span>${crypto?.low24h?.toFixed(2)} - ${crypto?.high24h?.toFixed(2)}</span>
          </div>
          <div className="mt-2 h-1 bg-muted rounded-full overflow-hidden">
            <div 
              className={`h-full rounded-full ${
                isPositive ? 'bg-success' : 'bg-destructive'
              }`}
              style={{ 
                width: `${((crypto?.price - crypto?.low24h) / (crypto?.high24h - crypto?.low24h)) * 100}%` 
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CryptoCard;